import React from "react";
import { Col, Row } from "antd";
import { template, setLocalStorage } from "@reco-m/core";
import { ViewComponent, Banner } from "@reco-w/core-ui";
import { Namespaces } from "@reco-w/aliyun-models";

export namespace Problem {
    export interface IProps extends ViewComponent.IProps {}

    export interface IState extends ViewComponent.IState {}

    export class Component<P extends IProps = IProps, S extends IState = IState> extends ViewComponent.Base<P, S> {
        namespace = Namespaces.aliyun;

        componentMount() {
            window.scroll(0, 0);
            setLocalStorage("selectedMenu", "aliyun"); // 设置被选中的菜单
        }
        componentDidMount() {}

        renderBody(): React.ReactNode {
            return (
                <div className="content">
                    <Banner.Component bimg="assets/images/banner/aliyun.png" text={<div className="home-banner-text">
                        <div className="banner-text-name1">常见问题</div>
                    </div>} />
                    <div className="container">
                        <Row className="mv50 problem-box" gutter={[115, 50]}>
                            <Col span={24}>
                                <div className="wenda">
                                    <div className="text1">问：如何获取折扣？</div>
                                    <div className="text2">
                                        答：首先需要提供个邮箱和个人姓名或者企名称给我们客服，然后我们会发链接到您邮箱里面，您通过邮箱里的链接注册成为阿里云的会员。有公司的尽量用公司注册，有时会有优惠，有时优惠力度也高于个人客户。
                                    </div>
                                </div>
                            </Col>
                            <Col span={24}>
                                <div className="wenda">
                                    <div className="text1">问：我已经有老账号了可以关联吗？</div>
                                    <div className="text2">
                                        答：可以的，如果方便最好可以新注册一个账号来进行产品关联！QQ邮箱也可以通过别名命名的方式来实现1个qq邮箱注册多个阿里账户。
                                    </div>
                                </div>
                            </Col>
                            <Col span={24}>
                                <div className="wenda">
                                    <div className="text1">问：购买阿里云服务器，关联帐号的链接几天内有效？</div>
                                    <div className="text2">
                                        答：我们发到您邮箱的关联链接是在注册账号后24小时内（1天）有效的，重发操作只能在客户账号添加24小时内进行操作，请收到关联邮件后即刻操作关联！
                                    </div>
                                </div>
                            </Col>
                            <Col span={24}>
                                <div className="wenda">
                                    <div className="text1">问：买了阿里云可以帮忙配置环境么？</div>
                                    <div className="text2">
                                        答：我们这边的技术可以帮您搭建基础环境，环境简单的可以很快完成，环境复杂的，我们也会努力尽快完成，我们的实力毋庸置疑。
                                    </div>
                                </div>
                            </Col>
                            <Col span={24}>
                                <div className="wenda">
                                    <div className="text1">问：支付宝不能实名认证了，提示绑定手机号超限是什么规则？</div>
                                    <div className="text2">答：一个支付宝账号只能实名认证5个阿里云账号，一个手机号也只能绑定5个阿里账号</div>
                                </div>
                            </Col>
                            <Col span={24}>
                                <div className="wenda">
                                    <div className="text1">问：不懂阿里云怎么使用，您们有哪些方面可以服务？</div>
                                    <div className="text2">
                                        答：您不用担心后面的使用问题，我们这边技术会跟进到位的，我们的技术支持队伍也是多年的团队了，还有好几个云架构师，请尽管放心使用，售后服务保障让您满意。
                                    </div>
                                </div>
                            </Col>
                            <Col span={24}>
                                <div className="wenda">
                                    <div className="text1">问：阿里云账号关联您们后，您们是不是就能操作我们的服务器了，那不是很不安全？</div>
                                    <div className="text2">答：您购买的产品是您的私人物品，操作都是在阿里云官网上面的，我们都是没有权限查看和操作的，这个您大可放心。</div>
                                </div>
                            </Col>
                            <Col span={24}>
                                <div className="wenda">
                                    <div className="text1">问：阿里云的ECS服务器可以先试用么？试用得好，我们再买多年都是可以的。</div>
                                    <div className="text2">
                                        答：您可以选择所需配置按量付费做测试，也可以选择包年包月的购买1周的服务来先做测试用的。在测试过程中有什么问题随时联系我这边协助您解决。
                                    </div>
                                </div>
                            </Col>
                            <Col span={24}>
                                <div className="wenda">
                                    <div className="text1">问：购买阿里云服务器能退款吗？</div>
                                    <div className="text2">
                                        答：阿里云官方承诺5天内无理由退款，故障100倍赔偿，备案多久时间赠送多久时间，阿里云官方7×24小时售后服务，真正做到购买无忧、使用无忧。网上还有阿里云服务器
                                        ECS服务器访问异常问题排查指引。
                                    </div>
                                </div>
                            </Col>
                            <Col span={24}>
                                <div className="wenda">
                                    <div className="text1">问：购买了阿里云能开发票吗？发票金额是多少？合同怎么申请呢？</div>
                                    <div className="text2">
                                        答：发票申请是直接在您的阿里云账号的费用中心申请，发票的金额是阿里云产品的原价（注：发票填写只能填写一次后期就不能修改了）；合同有草稿合同和正式合同，如果需要合同申请款项，
                                        需要先把配置选好提交订单 然后就可以申请草稿合同了，等订单支付成功后是可以转为正式合同的
                                    </div>
                                </div>
                            </Col>
                            <Col span={24}>
                                <div className="wenda">
                                    <div className="text1">问：阿里云账号的余额是否可以申请提现？</div>
                                    <div className="text2">
                                        答：可以提现的，但要看余额是之前没有消费完的还是退款的余额。没有消费完的余额申请提现很快，但是如果是退款的余额而且之前有开过发票，是需要先把发票退回给阿里云财务后再按照流程一步一步操作申请提现，大概需要几个工作日。
                                    </div>
                                </div>
                            </Col>
                            <Col span={24}>
                                <div className="wenda">
                                    <div className="text1">问：阿里云服务器按量付费是否有折扣？ 后期根据需求是否可以升级配置呢?</div>
                                    <div className="text2">
                                        答：按量付费是没有折扣的，因为根据配置的需求结算出来的价格是以每小时收费，而且按量付费的产品是不能升级配置的。所以一般建议重新购买按年付的
                                        这样才是比较划算的！
                                    </div>
                                </div>
                            </Col>
                            <Col span={24}>
                                <div className="wenda">
                                    <div className="text1">问：阿里云一年多少钱？</div>
                                    <div className="text2">
                                        答：阿里云服务器除了个别活动款的配置价格是固定的外，其他的都要看具体配置才能知道价格，配置高价格就高，配置低相对的价格就会低一些，按需购买才能保证最好的使用效果哈。
                                    </div>
                                </div>
                            </Col>
                            <Col span={24}>
                                <div className="wenda">
                                    <div className="text1">问：活动款的配置需要注意的事项？</div>
                                    <div className="text2">
                                        答：活动款的配置带宽都是默认的1M 而且不含数据云盘，您购买后需要购买一块数据盘，该盘是按量付费的 以每小时0.01元收费
                                        一年算下来也大概就是80元的样子，也不贵！切记不能把软件或者是数据放在系统盘之上，如果软件系统占用cup和内存过高
                                        那么远程桌面登陆时会受到一些影响，不那么顺畅，严重的会黑屏或者是连接不了。
                                    </div>
                                </div>
                            </Col>
                            <Col span={24}>
                                <div className="wenda">
                                    <div className="text1">问：我就是个简单的商城网站，用什么配置的服务器合适呢？</div>
                                    <div className="text2">
                                        答：如果是企业网站，用一般的配置就可以了，服务器每年价格在5k左右，具体还要看您们网站每天购买人数或者同一时间购买的人数等来确定具体配置。ECS服务器是随时都可以升降配置的，所以不用担心配置不够用。您对购买配置把握不准，可以咨询我们的专业客服哈！
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </div>
            );
        }
    }

    export const Page = template(Component, (state) => state[Namespaces.aliyun]);
}
